import { createBrowserRouter, Navigate } from "react-router-dom";
import { PageLayout } from "@/core/layout/PageLayout/PageLayout.tsx";
import { ErrorPage } from "@/core/pages/error/ErrorPage.tsx";
import { ApplicationError } from "@/core/api/model/error.ts";

const BASE_URL = import.meta.env.VITE_BASE_URL;

export const appRouter = createBrowserRouter(
    [
        {
            path: "/",
            Component: PageLayout,
            errorElement: <ErrorPage error={ApplicationError.UNKNOWN} />,
            children: [
                { path: "/", lazy: () => import("@/core/pages/HomePage/HomePage.tsx") },
                { path: "/homepage", element: <Navigate replace to="/" /> },
                { path: "/login", element: <Navigate replace to="/" /> },
                {
                    path: "/reports",
                    lazy: () => import("@/features/reports/pages/ReportOverviewPage/ReportOverviewPage.tsx"),
                },
                {
                    path: "/analysis",
                    lazy: () => import("../../features/evaluations/page/EvaluationPage.tsx"),
                },
                {
                    path: "/administration",
                    children: [
                        {
                            index: true,
                            lazy: () => import("@/core/pages/admin/AdminOverviewPage/AdminOverviewPage.tsx"),
                        },
                        {
                            path: "catalog",
                            lazy: () => import("@/core/pages/admin/CatalogPage/CatalogPage.tsx"),
                        },
                        {
                            path: "publication",
                            lazy: () => import("@/core/pages/admin/PublicationPage/PublicationPage.tsx"),
                        },
                        {
                            path: "api-key",
                            lazy: () => import("@/core/pages/admin/ApiKeyPage/ApiKeyPage.tsx"),
                        },
                    ],
                },
                {
                    path: "/profile",
                    lazy: () => import("@/core/pages/ProfilePage/ProfilePage.tsx"),
                },
                {
                    path: "/reports/*",
                    children: [
                        {
                            path: "import",
                            lazy: () => import("@/features/import/ImportPage.tsx"),
                        },
                        {
                            path: "create",
                            lazy: () => import("@/features/reports/pages/CreateReportPage/CreateReportPage.tsx"),
                        },
                        {
                            path: "edit/:reportId/*",
                            lazy: () => import("@/features/reports/layout/EditReportPageLayout/EditReportPageLayout.tsx"),
                            children: [
                                {
                                    path: "step-1",
                                    lazy: () => import("@/features/reports/pages/ReportStepOnePage/ReportStepOnePage.tsx"),
                                },
                                {
                                    path: "step-2",
                                    lazy: () => import("@/features/reports/pages/ReportStepTwoPage/ReportStepTwoPage.tsx"),
                                },
                                {
                                    path: "step-3",
                                    lazy: () => import("@/features/reports/pages/ReportStepThreePage/ReportStepThreePage.tsx"),
                                },
                                {
                                    path: "step-4",
                                    lazy: () => import("@/features/reports/pages/ReportStepFourPage/ReportStepFourPage.tsx"),
                                },
                                {
                                    path: "step-5",
                                    lazy: () => import("@/features/reports/pages/ReportSummaryPage/ReportSummaryPage.tsx"),
                                },
                                { path: "*", element: <Navigate replace to="step-1" /> },
                            ],
                        },
                        { path: "*", element: <Navigate replace to="/" /> },
                    ],
                },
                {
                    path: "/impressum",
                    lazy: () => import("@/core/pages/ImpressumPage/ImpressumPage.tsx"),
                },
                {
                    path: "/privacy",
                    lazy: () => import("@/core/pages/PrivacyPage/PrivacyPage.tsx"),
                },
                {
                    path: "/accessibility",
                    lazy: () => import("@/core/pages/AccessibilityPage/AccessibilityPage.tsx"),
                },
                {
                    path: "*",
                    element: <ErrorPage error={ApplicationError.PAGE_NOT_FOUND} />,
                },
            ],
        },
    ],
    { basename: BASE_URL },
);
